export interface ICookiesJar {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

interface IStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

const writeStateToLocalStorage =
  (storage: IStorage) => (obj: Record<string, string | boolean | number>) =>
    storage.setItem("rnibCurrentState", JSON.stringify(obj));

const retrieveStateFromLocalStorage =
  (storage: IStorage) => (): Record<string, string | boolean | number> | null =>
    JSON.parse(storage.getItem("rnibCurrentState") as string); // Let silently fail

const writeTCsConsentToLocalStorage =
  (storage: IStorage) => (consent: boolean) => {
    storage.setItem("rnibTCsConsent", `${consent}`);
  };

const readTCsConsentFromLocalStorage = (storage: IStorage) => () => {
  const value = storage.getItem("rnibTCsConsent");

  if (!value || !/true|false/.test(value)) return null;
  else return JSON.parse(value) as boolean;
};

export const setupStorageAccess = (cookiesJar?: ICookiesJar) => {
  const storage: IStorage =
    cookiesJar !== undefined
      ? cookiesJar
      : ({
          getItem: localStorage.getItem,
          setItem: localStorage.setItem,
        } as IStorage);

  return {
    writeTCsConsentToStorage: writeTCsConsentToLocalStorage(storage),
    readTCsConsentFromStorage: readTCsConsentFromLocalStorage(storage),
    writeStateToStorage: writeStateToLocalStorage(storage),
    retrieveStateFromStorage: retrieveStateFromLocalStorage(storage),
  };
};
